<div class="container">
  <button
    type="button"
    class="close-button"
    aria-label="ダイアログを閉じる"
    [disabled]="saving"
    (click)="close()"
  >
    <mat-icon>close</mat-icon>
  </button>
  <h1 mat-dialog-title class="title">タグを編集</h1>

  <fieldset class="tag-section">
    <legend>タグ</legend>
    <div class="tag-list" aria-label="タグ一覧">
      @for (tagMaster of data.tagMasters; track tagMaster.id) {
        <mat-checkbox
          [checked]="isSelected(tagMaster.id)"
          [disabled]="saving"
          (change)="toggleTag(tagMaster.id, $event.checked)"
        >
          {{ tagMaster.name }}
        </mat-checkbox>
      }
    </div>
  </fieldset>

  @if (errorMessage) {
    <div class="error-message" role="alert">{{ errorMessage }}</div>
  }

  <div class="action-buttons">
    <button
      type="button"
      rectangle
      variant="secondary"
      [disabled]="saving"
      (click)="close()"
    >
      キャンセル
    </button>
    <button type="button" rectangle [disabled]="saving" (click)="save()">
      保存
    </button>
  </div>
</div>
